import { defineStore } from 'pinia';
import type { pageConfig } from '~/types/api';

export const useStore = defineStore('main', {
  state: () => ({
    pageConfig: null as pageConfig | null,
    isLoading: true as boolean,
    warns: [] as any[],
  }),
  actions: {
    setPageConfig (config: pageConfig) {
      this.pageConfig = config;
    },
    resetPageConfig () {
      this.pageConfig = null;
    },
    setLoading (loading: boolean) {
      this.isLoading = loading;
    },
    addWarn (e: any) {
      this.warns.push(e);
    },
  },
});
